<style src="./OcrReport.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content ocr-report">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="searchWithFilter">
        <div class="row">
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Veículo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="ABC1234"
                  class="form-control"
                  v-model="form.licencePlate"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">ID do Aviso</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="123456"
                  class="form-control"
                  v-model="form.idAviso"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="form.date"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Zona</label>
              <div class="col-sm-12">
                <select
                  class="form-control"
                  v-model="form.zone"
                  @change="selectZone"
                >
                  <option :value="-1">Todos</option>
                  <option
                    v-for="(zone, zoneIdx) in zones"
                    :key="zoneIdx"
                    :value="zone.id"
                  >
                    {{ zone.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Área</label>
              <div class="col-sm-12">
                <select
                  class="form-control"
                  v-model="form.area"
                  @change="selectArea"
                >
                  <option :value="-1">Todos</option>
                  <option
                    v-for="(area, areaIdx) in areas"
                    :key="areaIdx"
                    :value="area.id"
                  >
                    {{ area.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Setor</label>
              <div class="col-sm-12">
                <select class="form-control" v-model="form.parking">
                  <option :value="-1">Todos</option>
                  <option
                    v-for="(parking, parkingIdx) in parkings"
                    :key="parkingIdx"
                    :value="parking.id"
                  >
                    {{ parking.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="mail-box">
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="registro" title="Aviso Criado">R</th>
            <th class="imagem" title="Imagem Inserida">I</th>
            <th class="data">Data</th>
            <th class="placa">Placa</th>
            <th class="zone">Zona</th>
            <th class="area">Area</th>
            <th class="setor">Setor</th>
            <th class="aviso">Aviso</th>
            <th class="leitura">Leitura</th>
            <th class="foto" title="Foto"></th>
            <th class="local" title="Localização"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in resultList" :key="idx">
            <td class="registro">
              <i class="fa fa-check" v-if="item.registered"></i>
            </td>
            <td class="imagem">
              <i class="fa fa-check" v-if="item.imageInserted"></i>
            </td>
            <td class="data">{{ formatDate(item.registeredAt) }}</td>
            <td class="placa">{{ formatLicencePlate(item.licencePlate) }}</td>
            <td class="zone">
              <span class="badge badgezone">{{ item.zone }}</span>
            </td>
            <td class="area">
              <span class="badge badgearea">{{ getAreaById(item.areaId) }}</span>
            </td>
            <td class="setor">{{ item.empro.id_setor }}</td>
            <td class="aviso">{{ item.empro.id_aviso }}</td>
            <td class="leitura">{{ item.empro.id_leitura }}</td>
            <td class="foto">
              <a
                :href="
                  `https://peaceparking.app:3020/ocr-images/${item.fileName}`
                "
                target="_blank"
                v-if="item.imageInserted"
                ><i class="fa fa-photo"></i
              ></a>
            </td>
            <td class="local">
              <a
                v-if="item.geolocation.coordinates.length"
                :href="
                  `https://www.google.com/maps/search/?api=1&query=${item.geolocation.coordinates[0]}%2C${item.geolocation.coordinates[1]}`
                "
                target="_blank"
                ><i class="fa fa-location-arrow"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group paginatecontent" v-if="countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';
import { format } from 'date-fns';
import { mapState } from 'vuex';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        pageSkip: 0,
        pageLimit: 20,
        licencePlate: '',
        date: '',
        idAviso: '',
        zone: -1,
        area: -1,
        parking: -1,
      },
      countPages: 0,
      resultList: [],
      areas: [],
      parkings: [],
    };
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
    ...mapState({
      zones: state => state.OCR.zones,
    }),
  },
  mounted() {
    this.setStartDate();
    this.listAllParkings();
  },
  methods: {
    formatDate(value) {
      return format(new Date(value), "dd-MM-yyyy' 'HH:mm");
    },
    formatLicencePlate(v) {
      const addDash = v.slice(0, 3) + '-' + v.slice(-4);
      const toUpperCase = addDash.toLocaleUpperCase();
      return toUpperCase;
    },
    getAreaById(areaId) {
      const area = this.$store.getters['OCR/GetAreaById'](areaId);
      return area.name;
    },
    selectZone() {
      this.form.area = -1;
      this.form.parking = -1;
      const areas = this.$store.state.OCR.areas;
      this.areas = areas.filter(item => item.zoneId === this.form.zone);
    },
    selectArea() {
      this.form.parking = -1;
      const parkings = this.$store.state.OCR.parkings;
      this.parkings = parkings.filter(item => item.areaId === this.form.area);
    },
    setStartDate() {
      const dt = new Date();
      const inputDate = `${dt.getFullYear()}-${(dt.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${dt
        .getDate()
        .toString()
        .padStart(2, '0')}`;
      this.form.date = inputDate;
    },
    async listAllParkings() {
      try {
        await this.$store.dispatch('OCR/ListEmproParkings');
      } catch (error) {
        console.error(error);
      }
    },
    searchWithFilter() {
      this.pageSkip = 0;
      this.filterReport();
    },
    async filterReport() {
      this.showSpinner = true;
      this.resultList = [];

      const query = {
        ...this.form,
      };

      try {
        const reports = await this.$store.dispatch('OCR/ReportVehicles', {
          query,
        });
        this.resultList = reports.list;
        this.countPages = reports.countTotal;
      } catch (errors) {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
    nextPage() {
      if (this.form.pageSkip + this.form.pageLimit > this.countPages) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip + this.form.pageLimit;

      this.filterReport();
    },
    previousPage() {
      if (this.form.pageSkip === 0) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip - this.form.pageLimit;

      this.filterReport();
    },
  },
};
</script>
